import React from 'react';

import { BulkSuggestionMoreActions } from './BulkSuggestionMoreActions';
import { useBulkLabelSuggestionsActions } from './hooks/useBulkLabelSuggestionsActions';

type TimeSheetMoreActionProps = {
  fieldName: string;
};
export const TimeSheetMoreAction: React.FC<TimeSheetMoreActionProps> = ({
  fieldName
}: TimeSheetMoreActionProps) => {
  const {
    enableTimesheetActions,
    denyAllLabelSuggestionHandler
  } = useBulkLabelSuggestionsActions({ fieldName: fieldName });

  return (
    <BulkSuggestionMoreActions
      enableActions={enableTimesheetActions}
      denyAllSuggestionHandler={denyAllLabelSuggestionHandler}
      fieldName={fieldName}
    />
  );
};
